import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class CustomReportConfigSearchData extends EntityData<CustomReportConfigSearchData> {
    @identifier id: number;
    @field reportName: string;

    get formattedName(): string {
        return CustomReportConfigData.formatReportName(this.reportName);
    }
}

export class CustomReportConfigUIPropertiesData extends EntityData<CustomReportConfigUIPropertiesData> {
    @field showDate: boolean;
    @field showSingleDate: boolean;

    @field showMovementType: boolean;
    @field showAccessRoleOption: boolean;
    @field showEmployeeStatusOption: boolean;

    @field showPendingReceiveOrderOption: boolean;
    @field showPendingStockTransferOption: boolean;
    @field showPurchaseOrderRecivedOption: boolean;
    @field showPurchaseOrderRecivableOption: boolean;
    @field showPurchaseOrderPendingOption: boolean;

    @field showBestSellerOptions: boolean;

    @field showEmployeeList: boolean;
    @field showSupplierList: boolean;
    @field showInventoryList: boolean;
    @field showLocationOutlet: boolean;
    @field showLocationList: boolean;
    @field showOutletGroupList: boolean;

    get showOptions(): boolean {
        return this.showMovementType || this.showAccessRoleOption || this.showEmployeeStatusOption ||
            this.showPendingReceiveOrderOption || this.showPendingStockTransferOption || this.showPurchaseOrderRecivedOption ||
            this.showPurchaseOrderRecivableOption || this.showPurchaseOrderPendingOption || this.showBestSellerOptions ||
            this.showOutletGroupList || this.showLocationOutlet;
    }
}

export class CustomReportConfigData extends EntityData<CustomReportConfigData> {
    @identifier id: string;
    @field reportName: string;
    @component properties: CustomReportConfigUIPropertiesData;

    get formattedName(): string {
        return CustomReportConfigData.formatReportName(this.reportName);
    }

    static formatReportName(reportName: string): string {
        return (reportName.charAt(0).toUpperCase() + reportName.slice(1))
            .replace(/ custom report$/i, "")
            .replace(/ report$/i, "");
    }
}
